// Sample Name with subsample setting would have subsample field Id as suffix, e.g. sampleName_DNA
export interface ISubSampleDetail {
  subSampleFieldId: string;
  sampleName: string;
}

export class SubSampleNameUtility {
  /**
   * Parse sub-sample name string to sample name and subsample field Id
   */
  public static parseSampleNameWithFieldId(subSampleName: string, subSampleNameSeparatorChar: string):
    ISubSampleDetail {
    var sampleNameAndFieldId = subSampleName.split(subSampleNameSeparatorChar);
    if (sampleNameAndFieldId.length < 2) {
      // Fall back to '_' instead, which was used originally for backward compatibility
      // Should remove in the future - TODO
      subSampleNameSeparatorChar = '_';
      sampleNameAndFieldId = subSampleName.split(subSampleNameSeparatorChar);
      if (sampleNameAndFieldId.length < 2) {
        // Shouldn't happen, if happens, throw error
        throw Error(`Sample name ${subSampleName} doesnt have the seperator ${subSampleNameSeparatorChar}.`);
      }
    }
    
    // original sample name can contain separator characters as well, e.g. 'sample-name-DNA'
    // The sub-sample field id would be the last segment after split
    // TODO: This is under the assumption that subsample field id won't contains separator character
    const subSampleFieldId = sampleNameAndFieldId[sampleNameAndFieldId.length - 1];
    // Join other segments for the sample name
    const sampleName = sampleNameAndFieldId.slice(0, sampleNameAndFieldId.length - 1).join(subSampleNameSeparatorChar);
    return {
      sampleName,
      subSampleFieldId
    };
  }

  /**
   * Converts subSampleName input into string format (joined with separator) e.g. sampleName-DNA
   */
  public static getSampleNameWithFieldId(subSampleName: ISubSampleDetail, subSampleNameSeparatorChar: string): string {
    return `${subSampleName.sampleName}${subSampleNameSeparatorChar}${subSampleName.subSampleFieldId}`;
  }
}
